// Libs
import React from 'react';
import { Modal } from 'react-bootstrap';

// Services & Helpers
import InstructorService from 'services/InstructorService';

// Components
import Loader from 'components/common/Loader';
import AvailabilitySelector from 'components/instructor/AvailabilitySelector';
import EditBookingModal from 'components/bookings/EditBookingModal';

//-------------------------------------------------------------------------------------------------------------------

class AvailabilityModal extends React.Component {

    constructor(props) {
        super(props);

        this.viewBooking = this.viewBooking.bind(this);
        this.editBookingModalRef = React.createRef();

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const availability = await InstructorService.getFullAvailability(this.props.instructor.slug, {
            startDate: this.props.startDate,
            endDate: this.props.endDate
        });
        this.setState({
            availability,
            isLoading: false
        });
    }

    async viewBooking(id) {
        await this.editBookingModalRef.current.show({
            bookingID: id
        });
        this.load();
    }

    render() {
        const {
            instructor
        } = this.props;
        if (!instructor) {
            return null;
        }

        return (<>
            <Modal show className="availability-modal">
                <div className="modal-header">
                    <h5>{instructor.firstName} {instructor.lastName}</h5>
                    {/*
                    <select
                        className="form-control"

                    >
                        <option></option>
                    </select>
                    */}
                    <button type="button" className="btn btn-secondary ms-auto ms-auto" onClick={() => this.props.onClose()}>
                        Close
                    </button>
                </div>
                <Modal.Body>
                    {this.renderInner()}
                </Modal.Body>
            </Modal>

            <EditBookingModal ref={this.editBookingModalRef} />
        </>);
    }
    
    renderInner() {
        const {
            highlightDates
        } = this.props;
        const {
            isLoading,
            availability
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (
            <AvailabilitySelector
                isScrollable
                highlightDates={highlightDates}
                workingDays={['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']}
                availability={availability}
                ignoreLocked
                onViewBooking={this.viewBooking}
            />
        );
    }
    
}

export default AvailabilityModal;